import React, {Fragment, useEffect} from "react";

// reactstrap components
import {
    Button,
    Card,
    CardFooter,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText,
    Row,
    Table,
    UncontrolledTooltip,
} from "reactstrap";
// layout for this page
// core components
import SimpleHeader from "components/Headers/SimpleHeader.js";
import CounselingService from "../../../services/counseling.service";
import PaginationWrapper from "../components/pagination";
import {paginate} from "../../../utils";
import useHistoryState from "../../../common/useHistoryState";
import classnames from "classnames";
import ReactDatetime from "react-datetime";
import moment from "moment";
import {Link} from "react-router-dom";
import {shopCategory} from "../shop/service/shop.category";
import {useHistory} from "react-router";
import donationService from "./donation.service";
import AuthService from "../auth/auth.service";

function DonationList() {
    const user = typeof window !== 'undefined' ? AuthService.getCurrentUser() : null;
    const history = useHistory();
    const [pageActive, setPageActive] = useHistoryState(1, 'pageActive');
    const [pageCount, setPageCount] = useHistoryState(1, 'pageCount');
    const [data, setData] = useHistoryState([], 'data');
    const [disease, setDisease] = useHistoryState('전체', 'disease');
    const [diff, setDiff] = useHistoryState('all', 'diff');
    const [active, setActive] = useHistoryState('all', 'active');
    const [startDate, setStartDate] = useHistoryState(moment().add(-1, 'month').format('YYYY-MM-DD'), 'startDate');
    const [endDate, setEndDate] = useHistoryState(moment().format('YYYY-MM-DD'), 'endDate');
    const [searchCurrent, setSearchCurrent] = useHistoryState(false, 'searchCurrent');
    const [search, setSearch] = useHistoryState('', 'search');
   // /charityHistory/detail?charityId=107&page=1 기부상세
    const handleReactDatetimeChange = (who, date) => {
        if (
            startDate &&
            who === "endDate" &&
            new Date(startDate) > new Date(date.format('YYYY-MM-DD'))
        ) {
            setStartDate(date.format('YYYY-MM-DD'));
            setEndDate(date.format('YYYY-MM-DD'));
        } else if (
            endDate &&
            who === "startDate" &&
            new Date(endDate) < new Date(date.format('YYYY-MM-DD'))
        ) {
            setStartDate(date.format('YYYY-MM-DD'));
            setEndDate(date.format('YYYY-MM-DD'));
        } else {
            if (who === "startDate") {
                setStartDate(date.format('YYYY-MM-DD'));
            } else {
                setEndDate(date.format('YYYY-MM-DD'));
            }
        }
    };

    const getClassNameReactDatetimeDays = (date) => {
        if (startDate && endDate) {
        }
        if (startDate && endDate && startDate !== endDate) {
            if (
                new Date(endDate) > new Date(date.format('YYYY-MM-DD')) &&
                new Date(startDate) < new Date(date.format('YYYY-MM-DD'))
            ) {
                return " middle-date";
            }
            if (endDate === date.format('YYYY-MM-DD')) {
                return " end-date";
            }
            if (startDate === date.format('YYYY-MM-DD')) {
                return " start-date";
            }
        }
        return "";
    };

    const render = () => {
        let option = { diff };
        // if (startDate && endDate) {
        //     option = {
        //         ...option,
        //         startDate,
        //         endDate
        //     }
        // }
        // if (active) {
        //     option = {
        //         ...option,
        //         active: true
        //     }
        // }
        if (user?.role === 'center') {
            option.company = user.name;
        }
        donationService.list(option)
            .then((res) => {
                if (res.code === 200) {
                    console.log(res);
                    setPageCount(res.charityList.length);
                    setData(paginate(res.charityList, pageActive, 10));
                }
            });
    }

    useEffect(() => {
        render();
    }, [pageActive, startDate, endDate, search, diff, active]);

    const statusChange = async (id, active) => {
        await donationService.update(id, {active});
        render();
    }

    return (
        <>
            <SimpleHeader name="Tables" parentName="Tables" />
            <Container className="mt--6" fluid>
                <Row>
                    <div className="col">
                        <Card>
                            <CardHeader className="border-0">
                                <Row className="py-3">
                                    <Col xs="11">
                                        <Form>
                                            <Row>
                                                <Col xs="3">
                                                    <label className=" form-control-label py-2">
                                                    </label>
                                                    <FormGroup>
                                                        <InputGroup
                                                            className={classnames("input-group-merge", {
                                                                focused: searchCurrent,
                                                            })}
                                                        >
                                                            <InputGroupAddon addonType="prepend">
                                                                <InputGroupText>
                                                                    <i className="fas fa-search" />
                                                                </InputGroupText>
                                                            </InputGroupAddon>
                                                            <Input
                                                                placeholder="제목으로 검색"
                                                                type="text"
                                                                value={search}
                                                                onChange={(e) => setSearch(e.target.value)}
                                                                onFocus={(e) => setSearchCurrent(true)}
                                                                onBlur={(e) => setSearchCurrent(false)}
                                                            />
                                                        </InputGroup>
                                                    </FormGroup>
                                                </Col>
                                                <Col xs="2">
                                                    <label className=" form-control-label">
                                                        게시 날짜
                                                    </label>
                                                    <FormGroup>
                                                        <ReactDatetime
                                                            inputProps={{
                                                                placeholder: "",
                                                            }}
                                                            value={startDate}
                                                            locale={'ko'}
                                                            timeFormat={false}
                                                            dateFormat={'YYYY-MM-DD'}
                                                            onChange={(e) =>
                                                                handleReactDatetimeChange("startDate", e)
                                                            }
                                                            renderDay={(props, currentDate, selectedDate) => {
                                                                let classes = props.className;
                                                                classes += getClassNameReactDatetimeDays(
                                                                    currentDate
                                                                );
                                                                return (
                                                                    <td {...props} className={classes}>
                                                                        {currentDate.date()}
                                                                    </td>
                                                                );
                                                            }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col xs="2">
                                                    <FormGroup>
                                                        <label className=" form-control-label py-2">
                                                        </label>
                                                        <ReactDatetime
                                                            inputProps={{
                                                                placeholder: "",
                                                            }}
                                                            value={endDate}
                                                            locale={'ko'}
                                                            timeFormat={false}
                                                            dateFormat={'YYYY-MM-DD'}
                                                            onChange={(e) =>
                                                                handleReactDatetimeChange("endDate", e)
                                                            }
                                                            renderDay={(props, currentDate, selectedDate) => {
                                                                let classes = props.className;
                                                                classes += getClassNameReactDatetimeDays(
                                                                    currentDate
                                                                );
                                                                return (
                                                                    <td {...props} className={classes}>
                                                                        {currentDate.date()}
                                                                    </td>
                                                                );
                                                            }}
                                                        />
                                                    </FormGroup>
                                                </Col>
                                                <Col xs="3">
                                                    <label className=" form-control-label">
                                                        활성화
                                                    </label>
                                                    <FormGroup>
                                                       <Input
                                                           type="select"
                                                           value={active}
                                                           name="active"
                                                           onChange={(e) => setActive(e.target.value)}
                                                       >
                                                           <option>전체</option>
                                                           <option value="true">on</option>
                                                       </Input>
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="6">
                                        <h3 className="mt-2">기업부 기부 관리</h3>
                                    </Col>
                                    {user?.role === 'center' ? null : (
                                      <Col className="text-right">
                                          <Button color="default" onClick={(e) => history.push('/admin/donationForm')}>
                                              등록하기
                                          </Button>
                                      </Col>
                                    )}
                                </Row>
                            </CardHeader>

                            <Table className="align-items-center table-flush" responsive striped>
                                <thead className="thead-light">
                                    <tr>
                                        <th className="text-center">우선순위</th>
                                        <th className="text-center">기부 업체명</th>
                                        <th className="text-center">제목</th>
                                        <th className="text-center">시작날짜</th>
                                        <th className="text-center">종료날짜</th>
                                        <th className="text-center">기부 유형</th>
                                        <th className="text-center">기부 목표</th>
                                        <th className="text-center">기부 상황</th>
                                        <th className="text-center">기부 상세</th>
                                        <th className="text-center">활성화</th>
                                        <th/>
                                    </tr>
                                </thead>
                                <tbody>
                                {data?.map((item, i) => {
                                    return [
                                        <Fragment key={i}>
                                            <tr>
                                                <td className="text-center">
                                                    {item.sortCode === 99999? '-': item.sortCode}
                                                </td>
                                                <td className="text-center">
                                                    {item.company}
                                                </td>
                                                <td className="text-center">
                                                    {item.title}
                                                </td>
                                                <td className="text-center">
                                                    {item.startDate}
                                                </td>
                                                <td className="text-center">
                                                    {item.endDate}
                                                </td>
                                                <td className="text-center">
                                                    {item.diff}
                                                </td>
                                                <td className="text-center">
                                                    {item.goal}
                                                </td>
                                                <td className="text-center">
                                                    {item.current}
                                                </td>
                                                <td className="text-center">
                                                    <Button
                                                        className="px-3"
                                                        color="warning"
                                                        size="sm"
                                                        onClick={() => history.push('/admin/donationCharityDetail/' + item.id)}
                                                    >
                                                        보기
                                                    </Button>
                                                </td>
                                                <td className="text-center">
                                                    <label className="custom-toggle custom-toggle-success center">
                                                        <input
                                                            checked={item.active}
                                                            type="checkbox"
                                                            onChange={(e) => statusChange(item.id, !item.active)}
                                                        />
                                                        <span
                                                            className="custom-toggle-slider rounded-circle"
                                                            data-label-off="No"
                                                            data-label-on="Yes"
                                                        />
                                                    </label>
                                                </td>
                                                <td className="text-center">
                                                    <Link className="table-action" to={'/admin/donationDetail/' + item.id}>
                                                        <i id={"donation" + item.id} className="fas fa-user-edit"/>
                                                    </Link>
                                                    <UncontrolledTooltip delay={0} target={"donation" + item.id}>
                                                        상세 보기
                                                    </UncontrolledTooltip>
                                                </td>
                                            </tr>
                                        </Fragment>
                                    ];
                                })}
                                </tbody>
                            </Table>

                            <CardFooter className="py-4">
                                <PaginationWrapper
                                    isActive={pageActive}
                                    pageNumber={pageCount}
                                    callback={(page) => setPageActive(page)}
                                    itemPerPage={10}
                                />
                            </CardFooter>
                        </Card>
                    </div>
                </Row>
            </Container>
        </>
    );
}

export default DonationList;
